import Settings from "../../icons/config";
import Tooltip from "../tooltip";
import React from "react";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { IconButton } from "@mui/material";

export default function HelpHeader({ children, ...props }) {
  return (
      <Tooltip title="Ajuda">
        <IconButton {...props}>

          <QuestionMarkIcon
            sx={{ color: "#2B3A8B"}}
            size="small"
            
          />
        </IconButton>
      </Tooltip>
  );
}
